import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAppContext } from '../../contexts/app-guard'

// A stable address to hand out: sends an investor to their own "Connect your AI" page.
export const Route = createFileRoute('/app/connect-ai')({
  component: ConnectAiRedirect,
})

function ConnectAiRedirect() {
  const { memberships } = useAppContext()
  const investor = memberships.find((m) => m.type === 'investor')
  if (!investor) return null
  return <Navigate to="/app/investor/$id/connect-ai" params={{ id: investor.id }} />
}
